/**
 * Preferencias de descarga R2 ZIP (RANGE_ZIP): Legacy vs Coalescing.
 * Default: **legacy** (mismo comportamiento fiable que 0.20.60).
 * Coalescing queda opt-in (Settings / localStorage); requiere reload del estudio.
 */

export const R2_ZIP_RANGE_MODE = {
  LEGACY: 'legacy',
  COALESCING: 'coalescing',
}

export const R2_ZIP_RANGE_MODE_KEY = 'udv.r2ZipRangeMode.v2'
/** Clave anterior (default era coalescing); se ignora para no heredar el stall. */
export const R2_ZIP_RANGE_MODE_KEY_LEGACY = 'udv.r2ZipRangeMode'
export const R2_ZIP_RANGE_MODE_EVENT = 'udv-r2-zip-range-mode-changed'

/** Tamaño máximo de bloque agrupado (fondo). */
export const MAX_COALESCED_BLOCK_SIZE_BYTES = 2 * 1024 * 1024

/** Gap máximo entre payloads Part-10 para unir (cubre LFH ZIP). */
export const MAX_GAP_THRESHOLD_BYTES = 64 * 1024

/** Primer bloque de serie activa (TTFF). */
export const FIRST_BLOCK_MAX_BYTES = 1 * 1024 * 1024

/** Tope de instancias por bloque (evita stalls largos de decode). */
export const MAX_COALESCED_MEMBERS = 8

/** Fetchers lógicos en modo coalescing. */
export const COALESCING_FETCHERS = { min: 2, max: 3 }

/**
 * @param {string|null|undefined} raw
 * @returns {'legacy'|'coalescing'}
 */
export function normalizeR2ZipRangeMode(raw) {
  const s = raw != null ? String(raw).trim().toLowerCase() : ''
  if (
    s === R2_ZIP_RANGE_MODE.COALESCING ||
    s === '1' ||
    s === 'true'
  ) {
    return R2_ZIP_RANGE_MODE.COALESCING
  }
  // Sin valor / inválido / legacy → legacy (default fiable)
  return R2_ZIP_RANGE_MODE.LEGACY
}

/**
 * @returns {'legacy'|'coalescing'}
 */
export function getR2ZipRangeMode() {
  try {
    const raw = localStorage.getItem(R2_ZIP_RANGE_MODE_KEY)
    if (raw == null || String(raw).trim() === '') {
      return R2_ZIP_RANGE_MODE.LEGACY
    }
    return normalizeR2ZipRangeMode(raw)
  } catch (e) {
    return R2_ZIP_RANGE_MODE.LEGACY
  }
}

/**
 * @returns {boolean}
 */
export function isR2ZipRangeCoalescingEnabled() {
  return getR2ZipRangeMode() === R2_ZIP_RANGE_MODE.COALESCING
}

/**
 * @param {'legacy'|'coalescing'|boolean|string} mode
 * @returns {'legacy'|'coalescing'}
 */
export function setR2ZipRangeMode(mode) {
  let next = R2_ZIP_RANGE_MODE.LEGACY
  if (typeof mode === 'boolean') {
    next = mode ? R2_ZIP_RANGE_MODE.COALESCING : R2_ZIP_RANGE_MODE.LEGACY
  } else {
    next = normalizeR2ZipRangeMode(mode)
  }
  try {
    localStorage.setItem(R2_ZIP_RANGE_MODE_KEY, next)
  } catch (e) {
    /* ignore */
  }
  try {
    window.dispatchEvent(
      new CustomEvent(R2_ZIP_RANGE_MODE_EVENT, { detail: { mode: next } })
    )
  } catch (e) {
    /* ignore */
  }
  return next
}

/**
 * Concurrencia de fetchers cuando coalescing está activo.
 * @param {number} [baseParallel]
 * @returns {number}
 */
export function getCoalescingFetcherCount(baseParallel) {
  const base = Math.max(1, Number(baseParallel) || COALESCING_FETCHERS.max)
  return Math.max(
    COALESCING_FETCHERS.min,
    Math.min(COALESCING_FETCHERS.max, base)
  )
}
